module.exports = __webpack_public_path__ + "static/media/logo_login.ad1d7b5e.png";